const Styles = {
    boxContainer: {
        p:2,
        height:'100%',
        ml:4
    }
}

export default Styles;